<template>
  <div class="content">
    <system :leftList="leftList"></system>
    <div class="pageBox">
      <div class="breadcrumb">
        <el-breadcrumb separator="/">
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item>添加结算授权</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="pageSerch">
        <el-card class="box-card" shadow="never">
          <div slot="header" class="clearfix">
            <span class="cardTitle">添加结算授权</span>
          </div>
          <div
            v-for="(item, index) in tableData"
            :key="index"
            class="boxBorder"
          >
            <div style="display: flex">
              <div>
                <div style="margin-bottom: 15px">
                  <span style="font-weight: 600">授权单笔最大金额：</span>
                  <el-input
                    v-model="codeList[index].bigMoney"
                    style="width: 300px"
                    type="number"
                  ></el-input>
                </div>
                <div style="margin-bottom: 15px">
                  <span style="font-weight: 600">授权单日最大金额：</span>
                  <el-input
                    v-model="codeList[index].money"
                    style="width: 300px"
                    type="number"
                  ></el-input>
                </div>
                <div style="margin-bottom: 15px">
                  <span style="font-weight: 600">授权开始日期：</span>
                  <el-input
                    v-model="codeList[index].time"
                    placeholder="如：20250101"
                    style="width: 300px"
                  ></el-input>
                </div>
                <div style="margin-bottom: 15px">
                  <span style="font-weight: 600">授权截至日期：</span>
                  <el-input
                    v-model="codeList[index].time1"
                    placeholder="如：20250101"
                    style="width: 300px"
                  ></el-input>
                </div>

                <el-button
                  v-loading="codeList[index].loading"
                  type="primary"
                  style="margin-top: 20px"
                  @click="confrim(item, index)"
                  >提交授权申请</el-button
                >
              </div>
              <div style="margin-left: 50px">
                <div style="margin-bottom: 15px">
                  <span style="font-weight: 600">授权有效期开始时间：</span>
                  {{ item.startDate }}
                </div>
                <div style="margin-bottom: 15px">
                  <span style="font-weight: 600">授权有效期结束时间：</span>
                  {{ item.endTime }}
                </div>
                <div style="margin-bottom: 15px">
                  <span style="font-weight: 600">说明：</span
                  >结算授权操作有效期为1年，每年向银行获取一次授权
                </div>
                <div>
                  <div style="margin-bottom: 15px">
                    <span style="font-weight: 600">账户名称：</span
                    >{{ item.accountName }}
                  </div>
                  <div style="margin-bottom: 15px">
                    <span style="font-weight: 600">账户号：</span
                    >{{ item.pendingAccts }}
                  </div>
                  <div
                    style="
                      display: flex;
                      align-items: center;
                      margin-bottom: 15px;
                    "
                  >
                    <div>
                      <span style="font-weight: 600">授权手机号：</span
                      >{{ item.phone }}
                    </div>
                  </div>
                  <div
                    style="
                      display: flex;
                      align-items: center;
                      margin-bottom: 15px;
                    "
                  >
                    <div>
                      <span style="font-weight: 600">手机验证码：</span>
                    </div>
                    <el-input
                      maxlength="20"
                      v-model="codeList[index].code"
                      placeholder="请输入手机验证码"
                      style="width: 300px; margin-left: 10px"
                    ></el-input>
                  </div>
                </div>
                <el-button
                  v-loading="codeList[index].loading2"
                  type="primary"
                  style="margin-top: 20px"
                  @click="save(item, index)"
                  >提交授权</el-button
                >
              </div>
            </div>
          </div>
        </el-card>
      </div>
    </div>
  </div>
</template>

<script>
import system from "../../components/system_left.vue";
export default {
  components: {
    system,
  },
  data() {
    return {
      leftList: this.Plugins.financeData(),
      codeList: [],
      tableData: [],
    };
  },
  mounted() {
    this.getList();
  },
  methods: {
    getList() {
      this.$axios
        .post(`/admapi/settlement/getInnerAccountPassed`)
        .then(({ data }) => {
          this.tableData = data;
          for (var i = 0; i < data.length; i++) {
            this.codeList.push({
              code: "",
              bigMoney: "",
              money: "",
              time: "",
              time1: "",
              loading: false,
              loading2: false,
            });
          }
        })
        .catch()
        .finally();
    },
    // 提交授权
    save(val, val1) {
      this.codeList[val1].loading2 = true;
      this.$axios
        .post(`/admapi/settlement/settleAuthentic`, {
          optType: "SETTLE_AUTH_CONFIRM",
          messageCaptcha: this.codeList[val1].code,
          virtualAcctNo: val.pendingAccts,
          customNo: val.platformCustomerNo,
          authPhone: val.phone,
          authType: "2",
          tranNo: val.tranNo,
          accountId: val.id,
        })
        .then(({ data }) => {
          this.$message.success("授权提交成功");
          this.$router.push({ path: "/authorization" });
        })
        .catch((this.codeList[val1].loading2 = false))
        .finally();
    },
    // 提交授权申请
    confrim(val, val1) {
      this.codeList[val1].loading = true;
      this.$axios
        .post(`/admapi/settlement/settleAuthentic`, {
          optType: "SETTLE_AUTH_APPLY",
          amtMaxOrder: this.codeList[val1].bigMoney,
          amtMaxDay: this.codeList[val1].money,
          startDate: this.codeList[val1].time,
          endDate: this.codeList[val1].time1,
          virtualAcctNo: val.pendingAccts,
          customNo: val.platformCustomerNo,
          authPhone: val.phone,
          authType: "2",
          accountId: val.id,
        })
        .then(({ data }) => {
          this.$message.success("授权申请提交成功，请填写验证码完成授权");
          this.getList();
        })
        .catch((this.codeList[val1].loading = false))
        .finally();
    },
  },
};
</script>
<style scoped>
.el-popover {
  padding: 0px 16px !important;
  box-sizing: border-box;
  border: none;
  min-width: 0;
}
.boxBorder {
  border-bottom: 1px solid #e4e7ed;
  padding-bottom: 50px;
  margin-bottom: 30px;
}
.boxBorder:last-child {
  border-bottom: none;
}
.boxBorder:first-child {
  margin-top: 0;
}
</style>
